import { DomSanitizer } from '@angular/platform-browser';
import { ProgramExitTypeSelectorApiModel } from '../../site-settings/program-exit-types/ProgramExitTypeSelectorApiModel';

export class EmployeeSuccessReportFilterSelectorsApiModel {
  public ExitTypes: ProgramExitTypeSelectorApiModel[] = [];

  public deserialize(data: Object, domSanitizer: DomSanitizer): EmployeeSuccessReportFilterSelectorsApiModel {
    Object.assign(this, data);

    this.ExitTypes = [
      Object.assign(new ProgramExitTypeSelectorApiModel(), {
        Id: null,
        Name: 'All Types'
      })
    ].concat(this.ExitTypes.map((x) => new ProgramExitTypeSelectorApiModel().deserialize(x, domSanitizer)));

    return this;
  }
}
